import { render, staticRenderFns } from "./LoginWithPassword.vue?vue&type=template&id=04a69dc6"
import script from "./LoginWithPassword.vue?vue&type=script&lang=js"
export * from "./LoginWithPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports